module.exports = __webpack_public_path__ + "img/icon-header-myesim.9c1b2d7.svg";